// BriefBioRando.js

import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import './Bulletin.css';

const ABBR = [
  'mr.', 'mrs.', 'ms.', 'dr.', 'prof.', 'sr.', 'jr.',
  'inc.', 'ltd.', 'co.', 'vs.', 'etc.', 'e.g.', 'i.e.'
];

const isAbbreviation = (word) => {
  const cleaned = word.toLowerCase().replace(/[^a-z.]/g, '');
  return ABBR.includes(cleaned);
};

const splitText = (text = '') => {
  const words = text.trim().split(/\s+/);
  const sentences = [];
  let currentSentence = [];

  words.forEach((word, idx) => {
    currentSentence.push(word);
    const isLastWord = idx === words.length - 1;
    const endsWithPunctuation = /[.!?]$/.test(word);

    if ((endsWithPunctuation && !isAbbreviation(word)) || isLastWord) {
      sentences.push(currentSentence.join(' '));
      currentSentence = [];
    }
  });

  return sentences;
};

const BriefBioRando = () => {
  const [bios, setBios] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [clickedIds, setClickedIds] = useState(() => {
    const saved = localStorage.getItem('clickedBriefBios');
    return saved ? JSON.parse(saved) : {};
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBios = async () => {
      const snapshot = await getDocs(collection(db, 'briefBios'));
      const bioList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setBios(bioList);
      setCurrentIndex(Math.floor(Math.random() * bioList.length));
    };
    fetchBios();
  }, []);

  const showRandom = () => {
    if (bios.length < 2) return;
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * bios.length);
    } while (newIndex === currentIndex);
    setCurrentIndex(newIndex);
  };

  const handleNameClick = (id) => {
    const updated = { ...clickedIds, [id]: true };
    setClickedIds(updated);
    localStorage.setItem('clickedBriefBios', JSON.stringify(updated));
    navigate(`/briefbios/${id}`);
  };

  const bio = bios[currentIndex];
  if (!bio) return <p>Loading...</p>;

  return (
    <div className="face-voting-container">
      <div className="face-question-box">
        <h2
          onClick={() => handleNameClick(bio.id)}
          style={{
            cursor: 'pointer',
            color: clickedIds[bio.id] ? '#551A8B' : '#1a0dab',
            textDecoration: 'none'
          }}
        >
          {bio.name}
        </h2>

        <div className="faces-row" style={{ justifyContent: 'center' }}>
          <div className="face-card">
            <div className="face-image-border-wrapper" style={{ width: 260, height: 260 }}>
              <img
                src={bio.imageUrl}
                alt={bio.name}
                className="voting-face-img"
                style={{ objectFit: 'cover', width: '100%', height: '100%' }}
              />
            </div>
          </div>
        </div>

        <div style={{ marginTop: 20, fontSize: 16, lineHeight: 1.6, color: '#333', textAlign: 'left' }}>
          {splitText(bio.bio).length > 1 ? (
            <ul style={{ listStyleType: 'disc', marginLeft: '20px', paddingInlineStart: '20px' }}>
              {splitText(bio.bio).map((sentence, idx) => (
                <li key={idx}>{sentence}</li>
              ))}
            </ul>
          ) : (
            <p>{bio.bio}</p>
          )}
        </div>

        {bio.sources?.length > 0 && (
          <div style={{ marginTop: 15 }}>
            <h4 style={{ marginBottom: 6, fontSize: 15 }}>Sources:</h4>
            <ul style={{ paddingLeft: 18, color: '#1a0dab', fontSize: 15 }}>
              {bio.sources.map((src, idx) => (
                src.name && src.link ? (
                  <li key={idx}>
                    <a
                      href={src.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#1a0dab', textDecoration: 'underline' }}
                    >
                      {src.name}
                    </a>
                  </li>
                ) : null
              ))}
            </ul>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
          <IconButton
            onClick={showRandom}
            sx={{
              color: '#007aff',
              p: 2,
              backgroundColor: '#f5f5f7',
              '&:hover': { backgroundColor: '#e8e8ed' }
            }}
          >
            <RefreshIcon sx={{ fontSize: 40 }} />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default BriefBioRando;


